import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceMinusWithUnderscore',
})
export class ReplaceMinusWithUnderscorePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }
    return value.replaceAll('-', '_');
  }
}
